/** Creates a wrapper Record/Dictionary where all keys are case-insensitive, this does not wrap recursively */
class CaseInsensitiveRecord {
  [key: string | symbol]: any;

  constructor(obj: any = {}) {
    const handler = {
      get(target: any, key: string | symbol) {
        if (typeof key === 'string') {
          const lowerKey = key.toLowerCase();
          const value = key in target ? target[key] : target[lowerKey];
          return value;
        }
        return target[key];
      },
      set(target: any, key: string | symbol, value: any): boolean {
        if (typeof key === 'string') {
          const lowerKey = key.toLowerCase();
          target[(key in target) ? key : lowerKey] = value;
          return true;
        }
        target[key] = value;
        return true;
      },
      deleteProperty(target: any, key: string | symbol): boolean {
        if (typeof key === 'string') {
          const lowerKey = key.toLowerCase();
          return delete target[(key in target) ? key : lowerKey];
        }
        return delete target[key];
      },
    };

    let newObj: any = obj;
    if (typeof obj === 'object') {
      newObj = new Proxy({}, handler);
      // Traverse the Original object converting string keys to lower case
      Object.keys(obj).forEach((key) => {
        if (typeof key === 'string') {
          const objKey = key.toLowerCase();
          // This will only pick the first instance of a value in case of duplicate keys with different casing
          if (!(key in newObj)) {
            newObj[objKey] = obj[key];
          }
        }
      });
    }
    // eslint-disable-next-line no-constructor-return
    return newObj; // object with lower cased keys
  }
}

export default CaseInsensitiveRecord;
